// Selo ImobTotal do rodapé dos ~685 sites de clientes → www.imobtotal.com.br/site-para-imobiliaria.
//
// Até 27/09/2026 o alvo e a âncora eram sorteados entre 8 slots (home, /crm-imobiliario,
// /site-para-imobiliaria, /ia-whatsapp) pensando em SEO — mas o link é nofollow desde 25/06
// (não passa autoridade), então o que conta é o CLIQUE e a conversão. Aba Vitrine do
// /leads/relatorio (27/09): quem chega em /site-para-imobiliaria vira lead 9,3% das vezes, contra
// 2,2% do /crm-imobiliario (quem clica acabou de ver um SITE e quer um site).
// Único ponto pra ajustar destino/texto depois.

export type ImobtotalBacklink = { href: string; anchor: string; title: string };

const BASE = 'https://www.imobtotal.com.br';
const PATH = '/site-para-imobiliaria';
const ANCHOR = 'Site feito pela ImobTotal — quer um assim para sua imobiliária?';
const TITLE = 'Site e CRM para imobiliária com IA no WhatsApp — ImobTotal';

// host = domínio do site do cliente (mantém a atribuição do canal "sitedeclientes"); cai pro
// codsite quando o host não está em escopo (rodape=3). Limpa protocolo/caminho pra não sujar o utm.
function campaignValue(host?: string, siteId?: string | number): string {
    const raw = host || (siteId != null ? String(siteId) : 'site');
    return raw.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
}

export function getImobtotalBacklink(siteId?: string | number, host?: string): ImobtotalBacklink {
    const campaign = encodeURIComponent(campaignValue(host, siteId));
    // utm_content separa os cliques do selo em faixa (27/09) dos formatos antigos nos leads.
    const href = `${BASE}${PATH}?utm_source=sitedeclientes&utm_medium=footer&utm_campaign=${campaign}&utm_content=selo-faixa`;
    return { href, anchor: ANCHOR, title: TITLE };
}
